import { render, staticRenderFns } from "./SelectTestPaper.vue?vue&type=template&id=3d0e1938"
import script from "./SelectTestPaper.vue?vue&type=script&lang=js"
export * from "./SelectTestPaper.vue?vue&type=script&lang=js"
import style0 from "./SelectTestPaper.vue?vue&type=style&index=0&id=3d0e1938&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports